module.exports = __webpack_public_path__ + "static/media/fun.7cfd0303.jpg";